import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/builds/prodigit/applux/applux-web/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/dist/main.d6f1a4c7d4.css",
    "revision": "bc96289d1847b726b0365beef8c980cc"
  },
  {
    "url": "assets/dist/main.fdedd387c10aba27ad2637d2047ef549.js",
    "revision": "fdedd387c10aba27ad2637d2047ef549"
  },
  {
    "url": "firebase-messaging-sw.js",
    "revision": "8d686995072d17cbe8862433aff16949"
  },
  {
    "url": "index.html",
    "revision": "105ec27500ed6e0147913c5acf8723f4"
  }
], {});








